module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_77_01.b42c4ace.png";